// @flow
import type { AvailableOptionActionType } from './actions';

export type AvailableOptionStateType = {
  creditableOptions: { [string]: Object[] },
  serviceOptions: Object[],
};

export const availableOptionsReducer = (state: AvailableOptionStateType = {}, action: AvailableOptionActionType) => {
  switch (action.type) {
    case 'SET_AVAILABLE_OPTIONS':
      return action.payload.options;
    default:
      return state;
  }
};
